import { render, staticRenderFns } from "./penaltyRecord.vue?vue&type=template&id=517ac8fe&scoped=true"
import script from "./penaltyRecord.vue?vue&type=script&lang=js"
export * from "./penaltyRecord.vue?vue&type=script&lang=js"
import style0 from "./penaltyRecord.vue?vue&type=style&index=0&id=517ac8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517ac8fe",
  null
  
)

export default component.exports